import React from 'react';
import { WebsiteTerms } from '../component/common/LegalDocuments';
import LegalPage from './LegalPage';

function ObchodniPodminky() {
    return <LegalPage title="Všeobecné obchodní podmínky">
        <WebsiteTerms />
    </LegalPage>;
}

export default ObchodniPodminky;
